<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p style="margin-left: -10px">委托商：</p>
        <el-input
          v-model="entrustIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p style="margin-left: -10px">适配车型：</p>
        <el-input
          v-model="customerCarName"
          size="mini"
          style="width: 150px"
          placeholder="请输入适配车型" />
      </div>
      <!-- <div class="navContainer" style="width: 400px">
        <p>有效起始：</p>
        <el-date-picker v-model="timeIpt[0]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="datetime" placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="timeIpt[1]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="datetime" placeholder="结束日期"/>
      </div> -->
      <div class="navContainer">
        <p>状态：</p>
        <el-select
          v-model="stateIpt"
          size="mini"
          filterable
          style="width: 150px"
          placeholder="请选择状态">
          <el-option
            v-for="item in stateOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input v-model="createByName" size="mini" style="width: 150px" placeholder="请输入录入人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          row-key="id"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column label="供应商类型" min-width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.supplierType == 1">公路</span>
              <span v-else-if="scope.row.supplierType == 2">水路</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="supplierName"
            label="供应商名称"
            min-width="140"
            show-overflow-tooltip
            align="center" />
          <el-table-column
            prop="consignorName"
            label="委托商名称"
            min-width="140"
            show-overflow-tooltip
            align="center" />
          <el-table-column
            prop="customerCarName"
            label="适配车型"
            min-width="100"
            show-overflow-tooltip
            align="center" />
          <el-table-column label="提车地" min-width="150" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.supplierType == 1">{{ scope.row.regionName }}</span>
              <span v-else-if="scope.row.supplierType == 2">{{ scope.row.portName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="有效起始" min-width="140" align="center" />
          <el-table-column prop="endDate" label="结束时间" min-width="140" align="center" />
          <el-table-column prop="taxRate" label="税率" min-width="100" align="center" />
          <el-table-column prop="price" label="单价" min-width="100" align="center" />
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <!--          <el-table-column prop="status" label="状态" align="center">-->
          <!--            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>-->
          <!--          </el-table-column>-->
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status === 0 || scope.row.status === 1"
                  size="mini"
                  :loading="scope.row.changeLoad"
                  class="yellow-bg"
                  type="primary"
                  @click="changeClick(scope.row.id, scope.row.status,scope.row)">
                  {{ !scope.row.status ? '修改' : '修改车型' }}
                </el-button>
                <el-button
                  v-if="scope.row.status == 0"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status == 1"
                  size="mini"
                  type="danger"
                  @click="disableClick(scope.row)"
                  >停用
                </el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog
      title="详情提车费"
      :visible.sync="detailDialogVisible"
      width="600px"
      center
      top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">供应商类型：</span>
              <span>{{ detailData.supplierType == 1 ? '公路' : '港口' }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">供应商名称：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">委托商名称：</span>
              <span>{{ detailData.consignorName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">提车地：</span>
              <span>{{
                detailData.supplierType == 1 ? detailData.regionName : detailData.portName
              }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">费用：</span>
                <span>{{ detailData.price }}</span>
              </div>
              <div>
                <span class="span1">税率：</span>
                <span>{{ detailData.taxRate }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">有效期始：</span>
                <span>{{ detailData.startDate }}</span>
              </div>
              <div>
                <span class="span1">结束时间：</span>
                <span>{{ detailData.endDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>适配车型</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.carModelList" border>
              <el-table-column type="index" label="序号" align="center" />
              <el-table-column prop="brandName" label="品牌" align="center" />
              <el-table-column prop="modelName" label="型号" align="center" />
              <el-table-column label="状态" align="center" width="160px">
                <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      center
      @close="dialogClose"
      :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="100px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <el-row>
              <el-col v-show="editType === 0">
                <el-form-item label="供应商类型：" style="margin-top: 10px" prop="supperType">
                  <el-radio-group
                    @change="supplier(companyData.supperType)"
                    v-model="companyData.supperType">
                    <el-radio :label="1">公路</el-radio>
                    <el-radio :label="2">水路</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="供应商：" prop="supplier">
                  <el-select
                    v-model="companyData.supplier"
                    size="mini"
                    filterable
                    style="width: 100%"
                    placeholder="请选择供应商"
                    @change="nameChange">
                    <el-option
                      v-for="item in supplierList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="委托商：" style="margin-top: 10px" prop="name">
                  <el-select
                    v-model="companyData.name"
                    filterable
                    size="mini"
                    style="width: 100%"
                    placeholder="请选择委托商"
                    value-key="id">
                    <el-option
                      v-for="item in nameOption"
                      :key="item.id"
                      :label="item.customer_name"
                      :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :class="{ mt10: editType === 1, mb10: editType === 1 }">
                <el-form-item label="适配车型：" style="margin-bottom: 0" prop="model">
                  <cascader
                    ref="cascader"
                    :options="modelOption"
                    :props="{
                      value: 'id',
                      label: 'model',
                      children: 'carModel',
                      multiple: true,
                    }"
                    :filed="'model'"
                    @getValue="getValue" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="提车区域：" prop="position">
                  <el-cascader
                    size="mini"
                    style="width: 100%"
                    ref="startPosition"
                    v-model="companyData.position"
                    placeholder="请选择提车区域"
                    :options="startPosition"
                    :props="props"
                    filterable
                    @change="handleChange"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="提车港口：" prop="startPort" style="margin-bottom: 20px">
                  <el-select
                    v-model="companyData.startPort"
                    filterable
                    value-key="id"
                    size="mini"
                    clearable
                    @change="$forceUpdate()"
                    placeholder="请选择提车港口">
                    <el-option
                      v-for="item in startPortList"
                      :key="item.id"
                      :label="item.supplier_name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='合同：' prop='contract' style="margin-top: 15px">
                  <el-select v-model="companyData.contract" filterable style="width: 100%" size="small"
                             placeholder="请选择合同" value-key="id">
                    <el-option
                      v-for="item in contractOption" :key="item.id" :label="item.name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col>
                <el-form-item label="起运地：" prop="address">
                 <el-select v-model="companyData.address" filterable size="mini" style="width:100%" placeholder="请选择起运地" value-key="id" @change="nameChange">
                   <el-option v-for="item in addressOption" :key="item.id" :label="item.address" :value="item"/>
                 </el-select>
                  <el-select v-if="companyData.type !==1" filterable v-model="companyData.address" size="mini" style="width:100%" placeholder="请选择起运地" value-key="id">
                    <el-option v-for="item in positionOption" :key="item.id" :label="companyData.type !==3?item.supplier_name:item.shorter_name" :value="item"/>
                  </el-select>
                  <el-cascader
                    size="mini"
                    style="width: 100%"
                    v-if="companyData.type===1"
                    v-model="companyData.address"
                    placeholder="请选择起运地"
                    :options="positionOption"
                    :props="{
                      value: 'id',
                      label:'customerName',
                      children: 'warehouseList'
                    }"
                    clearable filterable
                    @change="handleChange"
                    ></el-cascader>
                  <span v-if="companyData.address" style="color:#999;font-size: 12px;position:absolute;bottom:-25px;left:0;">{{companyData.type===1? startAddress :companyData.address.address}}</span>
                </el-form-item>
              </el-col> -->
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="费用：" prop="price">
                  <el-input
                    style="width: 100%"
                    type="number"
                    v-model="companyData.price"
                    placeholder="请输入费用"
                    autocomplete="off"
                    size="mini" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="税率%：" prop="taxRate">
                  <el-input
                    type="number"
                    v-model="companyData.taxRate"
                    placeholder="请输入税率"
                    autocomplete="off"
                    size="mini" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker
                    v-model="companyData.start"
                    size="mini"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效开始时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="editType === 0">
                <el-form-item label="结束日期：" prop="end">
                  <el-date-picker
                    v-model="companyData.end"
                    size="mini"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效结束时间"
                    default-time="23:59:59"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick"
              >确定
            </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="选择适配车型"
      :visible.sync="carVisible"
      width="600px"
      @close="carClose"
      center
      :close-on-click-modal="false"
      top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="item in selectCar"
              @click="selectRemove(item)">
              {{ item.name }}<i class="el-icon-close" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p>
              <i class="el-icon-plus" @click="brandAdd(item)" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="item in selectModel"
              @click="modelAdd(item)">
              <p>{{ item.name }}</p>
              <i class="el-icon-plus" />
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import {
    updateStatus,
    highwayLineSelectWaterSupplier,
    consignorHandoverList,
    consignorDetail,
    getCarSerieList,
    addConsignorHandover,
    reviseConsignorHandover,
    deleteConsignorHandover,
    customerInfoSelectList,
    getContractInfo,
    getContractPageList,
    addContract,
    deleteContractInfo, contractPageList,
  } from '@/service/financial';
  import {
    supplierPublicSelectDistributor,
    supplierPublicSelectPort,
    vehiclePublicSelectWarehouse,
    getSelectPort,
  } from '@/service/vehiclelog';
  import { getHighwayParam } from '../../../service/basicfile';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      steps,
      divBorder,
      cascader,
    },
    data() {
      return {
        supplierList: [],
        entrustIpt: '',
        stateIpt: '',
        customerCarName: '',
        createByName: '',
        timeIpt: ['', ''],
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        contractVisible: false,
        condition: {
          price: '',
          taxPrice: '',
        },
        contractTableData: [],
        contractLoad: false,
        page: 1,
        row: 10,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        dialogVisible: false,
        dialogTitle: '',
        changeLoad: false,
        addLoad: false,
        nameOption: [],
        payOption: [],
        modelOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        consignorMap: new Map(),
        positionOption: [],
        startPosition: [],
        startPortList: [],
        props: {
          value: 'id',
          label: 'cityName',
          children: 'children',
        },
        startAddress: '',
        companyData: {},
        contractOption: [],
        rules: {
          supplier: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          supperType: [
            {
              required: true,
              message: '请选择类型',
              trigger: 'change',
            },
          ],
          name: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'change',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'change',
            },
          ],
          model: [
            {
              required: true,
              message: '请选择适配车型',
              trigger: 'change',
            },
          ],
          taxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          start: [
            {
              required: true,
              message: '请选择有效开始时间',
              trigger: 'change',
            },
          ],
          end: [
            {
              required: true,
              message: '请选择有效结束时间',
              trigger: 'change',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择起运类型',
              trigger: 'change',
            },
          ],
          position: [
            {
              required: true,
              message: '请选择提车区域',
              trigger: 'change',
            },
          ],
          price: [
            {
              required: true,
              message: '请输入费用',
              trigger: 'blur',
            },
          ],
        },
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        editType: 0,
        checkTableData: [],
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    async mounted() {
      await this._consignorHandoverList();

      await this._getCarSerieList();
      const res2 = await customerInfoSelectList();
      if (res2.status !== 0) {
        this.$message.error(res2.message);
      } else {
        this.nameOption = res2.data;
      }
      // const res = await getCarSerieList();
      // if(res.status !== 0) this.$message.error(res.message);
      // else {
      //   this.allCar=res.data;
      //   this.selectBrand = res.data.map(item => {
      //     return {
      //       name: item.brand,
      //       id: item.id,
      //     }
      //   })
      //   res.data.forEach(item =>{
      //     if(item.carModel.length !== 0) this.allModel=[...this.allModel,...item.carModel]
      //   })
      // }
    },
    created() {
      this.startPosition = JSON.parse(sessionStorage.getItem('areaList'));
    },
    methods: {
      nameChange(val) {
        this.companyData.contract = ''
        this._contractPageList(val);
      },
      // 合同设置 —— 分页查询
      async _contractPageList() {
        let obj = {
          id: this.companyData.supplier,
        };
        let res = await contractPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认启用当前选中提车费设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            const res = await updateStatus({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._consignorHandoverList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      async supplier(type) {
        if (type == 1) {
          const res = await getHighwayParam('');
          this.supplierList = res.data;
        } else if (type == 2) {
          const res = await highwayLineSelectWaterSupplier('');
          this.supplierList = res.data;
        }
      },
      async _consignorHandoverList() {
        this.tableLoad = true;
        const res = await consignorHandoverList({
          consignorName: this.entrustIpt,
          status: this.stateIpt,
          rows: this.size,
          page: this.page,
          createByName: this.createByName,
          customerCarName: this.customerCarName
          // startDate:this.timeIpt[0]?this.timeIpt[0]:'',
          // endDate:this.timeIpt[1]?this.timeIpt[1]:'',
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      compareDate(d1, d2) {
        return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
      },
      // 结束时间
      dateChange1(val) {
        if (
          this.timeIpt[1] &&
          this.timeIpt[0] &&
          this.compareDate(this.timeIpt[0], this.timeIpt[1])
        ) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      //适配车型
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item, index) => {
            this.modelMap.set(item.id, item.model);
            this.brandMap.set(item.brand_id, item.brand_name);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
        console.log(this.modelOption);
      },
      // 根据区域获取港口
      async _getSelectPort(id, type) {
        let port = await getSelectPort(id);
        if (port.status !== 0) return this.$message.error(port.message);
        if (type == 1) {
          this.startPortList = port.data;
        } else {
          this.endPortList = port.data;
        }
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._consignorHandoverList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._consignorHandoverList();
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        this.$refs.cascader.value = [];
      },
      dateChange(date, date1) {
        if (date > date1) {
          return true;
        }
      },
      // 新增/修改 —— 确认
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (this.companyData.supperType == 2) {
              let port = this.companyData.startPort;
              if (port == null || port == undefined || port == '') {
                return this.$message.warning('港口不能为空！');
              }
            }
            const start = this.$refs['startPosition'].getCheckedNodes();
            if (this.companyData.price < 0) return this.$message.warning('费用不能小于0！');
            if (this.dateChange(this.companyData.start, this.companyData.end))
              return this.$message.warning('结束时间不得小于开始时间！');
            // let str ='';
            // let str2 ='';
            // this.brands2.forEach((item,index)=>{
            //   if(index===this.brands2.length-1) str+=item.id
            //   else str+=item.id+','
            // })
            // this.models2.forEach((item,index)=>{
            //   if(index===this.models2.length-1) str2+=item.id
            //   else str2+=item.id+','
            // })
            let shipmentId = this.companyData.position.join(',');
            let shipmentName = start[0].pathLabels.join('/');
            let { type, address, taxRate, model } = this.companyData;
            let obj = {
              regionId: this.companyData.position[2],
              consignorId: this.companyData.name,
              supplierType: this.companyData.supperType,
              supplierId: this.companyData.supplier,
              contractId: this.companyData.contract.id,
              // 提车区域
              shipmentId: '',
              shipmentName: '',
              // 提车港口
              portId:
                this.companyData.startPort && this.companyData.startPort.id
                  ? this.companyData.startPort.id
                  : '',
              // shipmentPortName: this.companyData.startPort.supplier_name,
              // brandId:str,
              // modelId:str2, shipmentType:type,
              //起运类型 1 委托商 二级下拉 返回为一个数组
              // 提车区域
              // shipmentId:type ==1 ? this.companyData.address[1]:this.companyData.address.id,
              // shipmentAddress:type ===1 ?this.companyData.address.id:'',
              // shipmentAddress:type == 1?this.consignorMap.get(address[1]).addr:address.address,
              // shipmentName:this.companyData.address.address,
              // 1 委托商 2 港口 3 经销商    港口 经销商 地址名称字段不一样 判断
              // shipmentName:type == 1?this.consignorMap.get(address[1]).warehouseName:type!=3? address.supplier_name:address.shorter_name,
              price: this.companyData.price,
              taxRate: taxRate,
              startDate: this.companyData.start,
              endDate: this.companyData.end,
              carModelList: model.map(item => {
                return {
                  modelId: item[1],
                  modelName: this.modelMap.get(item[1]),
                  brandId: item[0],
                  brandName: this.brandMap.get(item[0]),
                };
              }),
            };
            // 提车区域
            obj.shipmentId = shipmentId;
            obj.shipmentName = shipmentName;
            if (this.dialogTitle != '添加提车费') {
              obj.id = this.companyData.id;
              obj.status = this.companyData.status;
            }
            this.addLoad = true;
            const res =
              this.dialogTitle == '添加提车费'
                ? await addConsignorHandover(obj)
                : await reviseConsignorHandover(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._consignorHandoverList();
          } else {
            return false;
          }
        });
      },
      async positionChange(type) {
        this.companyData.address = {};
        if (type === 1) {
          //委托商 二级下拉
          this.startAddress = '';
          let consignorRes = await vehiclePublicSelectWarehouse();
          if (consignorRes.status !== 0) return this.$message.error(consignorRes.message);
          this.positionOption = consignorRes.data;
          this.positionOption.forEach((item, index) => {
            //warehouseList 数据重新构造
            this.positionOption[index].warehouseList = item.warehouseList.map(item => {
              this.consignorMap.set(item.id, item);
              return {
                id: item.id,
                customerName: item.warehouseName,
              };
            });
          });
          return;
        } else if (type === 2) {
          //港口
          let portRes = await supplierPublicSelectPort();
          if (portRes.status !== 0) return this.$message.error(portRes.message);
          this.positionOption = portRes.data;
          return;
        }
        //经销商
        const res = await supplierPublicSelectDistributor();
        if (res.status !== 0) return this.$message.error(res.message);
        this.positionOption = res.data;
      },
      handleChange(value) {
        // if (this.companyData.type===1) this.startAddress = this.consignorMap.get(value[1]).addr
        this.companyData.startPort = '';
        this._getSelectPort(value[value.length - 1], 1);
      },
      carClick() {
        this.carVisible = true;
        this.selectCar = [...this.selectedCar];
        this.brands = [...this.brands2];
        this.models = [...this.models2];
      },
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) {
            return this.$message.warning('上方已选择该品牌的全部车型！');
          } else if (this.selectCar[i].id === item.id)
            return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      carClose() {
        this.carVisible = false;
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => {
              return {
                id: item.id,
                name: item.brand_name,
                brandId: item.brand_id,
              };
            });
            break;
          }
        }
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认删除当前提车费设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await deleteConsignorHandover(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorHandoverList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认删除当前选中的提车费设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let res = await deleteConsignorHandover(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this.$message.success(res.message);
              await this._consignorHandoverList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      disableClick(data) {
        this.$confirm('确认停用当前提车费设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            // 调用启用弹窗
            let obj = {
              id: data.id,
              status: 2,
            };
            const res = await updateStatus(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorHandoverList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认停用当前提车费设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              // 调用启用弹窗
              const res = await updateStatus({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this.$message.success(res.message);
              await this._consignorHandoverList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的提车费设置！',
            type: 'warning',
          });
        }
      },
      // 详情
      async detailClick(id) {
        const res = await consignorDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        const res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.detailData.contractData = res1.data;
        this.detailDialogVisible = true;
      },
      // 修改
      async changeClick(id, type,row) {
        this.editType = type;
        row.changeLoad = true;
        this.dialogTitle = '修改提车费';
        const { data, message, status } = await consignorDetail(id);
        row.changeLoad = false;
        if (status !== 0) return this.$message.error(message);
        await this.supplier(data.supplierType);
        let name = '';
        if (data.contractCode != null && data.contractCode !== '') {
          name = data.contractCode + '-' + data.contractName;
        } else {
          name = null;
        }
        this.companyData = {
          ...data,
          supperType: data.supplierType,
          supplier: data.supplierId,
          name: data.consignorId,
          contract:{
            id: data.contractId,
            name:name
          },
          model:
            data.carModelList.length > 0
              ? data.carModelList.map(r => {
                  return [r.brandId, r.modelId];
                })
              : [],
          position: data.regionFullId.split('/'),
          startPort: data.portId,
          taxRate: data.taxRate,
          price: data.price,
          start: data.startDate,
          end: data.endDate,
        };
        await this._getSelectPort(data.regionId.split(',')[data.regionId.split(',').length - 1], 1);
        // 默认为港口及其他
        await this.positionChange(2);
        let res = await contractPageList({ id: this.companyData.supplier});
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.cascader.value = this.companyData.model;
        });
      },
      searchBtn() {
        this.page = 1;
        this._consignorHandoverList();
      },
      async addBtn() {
        this.editType = 0;
        this.dialogVisible = true;
        this.dialogTitle = '添加提车费';
        this.companyData = {
          transfer: 1,
          mention: 1,
          discharge: 1,
          address: '',
        };
        // 默认为港口及其他
        await this.positionChange(2);
      },
      resetBtn() {
        this.entrustIpt = '';
        this.stateIpt = '';
        this.timeIpt = ['', ''];
        this.customerCarName = ''
      },
      enableClick(data) {
        this.$confirm('确认启用当前提车费设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: data.id,
              status: 1,
            };
            const res = await updateStatus(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorHandoverList();
          })
          .catch(() => {});
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.companyData[filed] = subData;
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/consignorHandover/export?access_token=${token}&consignorName=${this.entrustIpt}&status=${this.stateIpt}&customerCarName=${this.customerCarName}`;
        window.exportExcelGet('/platform/price/consignorHandover/export', `consignorName=${this.entrustIpt}&status=${this.stateIpt}&customerCarName=${this.customerCarName}`)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .navContainer {
        display: inline-block;
        width: 230px;
        text-align: center;

        p {
          display: inline-block;
          width: 70px;
        }

        ::v-deep {
          .transportTitle {
            z-index: 99;
          }

          .el-table__body tr.current-row > td {
            background-color: #409eff;
            color: #fff !important;
          }

          .cell .el-form-item {
            padding: 0 2px;
          }

          .el-dialog__header {
            padding: 9px 20px 9px;
            background: #335483;
            text-align: center;
          }

          .el-dialog__headerbtn {
            top: 0px;
            height: 42px;
            line-height: 42px;
            right: 10px;
            font-size: 20px;

            .el-dialog__close {
              color: #fff;
              font-size: 25px;
            }
          }

          .el-dialog__title {
            color: #fff;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
          }

          .el-dialog__body {
            padding: 20px !important;
            max-height: 60vh;
            overflow-y: auto;
          }
        }
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
